import {FC} from 'react'
import {names} from 'shared/lib'
import {ArrowRight} from 'shared/ui/icons'
import styles from './styles.module.scss'

type SidebarItemProps = {
  isActive: boolean
  onClick: () => void
  label: string
}

export const SidebarItem: FC<SidebarItemProps> = ({
  isActive,
  onClick,
  label
}) => {
  return (
    <div
      className={names(
        styles.sidebarItem,
        isActive ? styles.sidebarItem_active : ''
      )}
      onClick={onClick}
    >
      <p className={styles.sidebarItemLabel}>{label}</p>
      <div className={styles.arrow}>
        <ArrowRight />
      </div>
    </div>
  )
}
